<!--
 * @Author: lyodon.li lyodon.li@feisu.com
 * @Date: 2025-02-14 16:22:17
 * @LastEditors: lyodon.li lyodon.li@feisu.com
 * @LastEditTime: 2026-08-06 17:47:35
 * @FilePath: /designcenter/src/App.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->

<template>
  <div class="loading-container" v-if="!isInitialized && !isPdfExportRoute">Loading...</div>
  <div v-else>
    <RouterView />
  </div>
</template>

<script setup lang="ts">
import { onMounted, nextTick, watch, onUnmounted, ref, computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { initProject } from '@/api/modules/project'
import { useHeaderStore } from '@/store/header'
import { useProjectStore } from '@/store/project'
import { storeToRefs } from 'pinia'
import { Cookie, handleFsLink, setLoginUrl, parseUrlParams } from '@/utils'
import * as Sentry from '@sentry/vue'
import { useUserStore } from '@/store/user'
import { PageTimeTracker } from '@/utils/analytics'
import { useLocaleStore } from '@/store/locale'
const headerStore = useHeaderStore()
const projectStore = useProjectStore()
const localeStore = useLocaleStore()
const route = useRoute()
const router = useRouter()
const userStore = useUserStore()

const isShare = ref(false)

const { isInitialized } = storeToRefs(projectStore)
const isPdfExportRoute = computed(() => route.name === 'PdfExport')
const isPdfPrintRoute = computed(() => isPdfExportRoute.value && route.query.mode === 'print')
let tracker: PageTimeTracker | null = null
// TODO: 权限校验应该在路由拦截器里面执行，并应该放在 App 的 onMounted 里面执行
onMounted(async () => {
  await router.isReady()
  await nextTick()
  // 使用优化后的 parseUrlParams 处理 URL 参数（支持 HTML 实体编码如 &amp;）
  const urlParams = parseUrlParams()
  const token = Cookie.get('token_new') || route.query.token || urlParams.token || ''

  if (!isPdfExportRoute.value) {
    projectStore.setCurrentProjectId(null)
    projectStore.setCurrentTemplateId(null)
  }
  await localeStore.loadTranslations([
    'pages/designCenter',
    'pages/placeDevices',
    'pages/project',
    'pages/guide',
    'productCatalog',
    'components/property',
    'components/toolbar',
    'components/layout',
    'components/common',
    'components/shareProject',
    'components/feedbackPopup',
    'components/helpCenter',
    'components/selectProject',
    'components/featureDesign',
    'components/productInfo',
    'pages/template',
    'operationManual',
  ])
  if (token) {
    if (import.meta.env.MODE == 'production') {
      tracker = new PageTimeTracker('Design Center')
    }
    localStorage.setItem('token_new', token)
    // 检查是否为分享链接（同时存在 projectId 和 share 参数）
    // const shareParam = urlParams.share
    const hasRouteQuery = Object.keys(route.query).length > 0
    const urlParams = hasRouteQuery ? route.query : parseUrlParams()
    const projectIdParam = urlParams.projectId

    // 只有在有 URL 参数且 share=1 时才走分享逻辑
    isShare.value = hasRouteQuery && Boolean(urlParams.share)

    // 处理 projectIdParam 可能为 string | string[] | null 的情况
    const projectIdStr = Array.isArray(projectIdParam) ? projectIdParam[0] : projectIdParam
    const projectId = projectIdStr ? parseInt(projectIdStr, 10) : NaN

    // PDF 导出页直接使用路由中的 projectId，不写回共享的 localStorage。
    if (isPdfExportRoute.value) {
      projectStore.$patch(state => {
        state.isInitialized = true
      })
      return
    }

    if (!isNaN(projectId) && projectId > 0) {
      projectStore.setCurrentProjectId(projectId)
    }

    if (isShare.value) {
      projectStore.$patch(state => {
        state.isInitialized = true
      })
    } else {
      await initProject()
        .then((res: unknown) => {
          if (res.data.projectId) {
            projectStore.setCurrentProjectId(res.data.projectId)
            projectStore.$patch(state => {
              state.isInitialized = true
            })
            if (res.data.templateId || (res.data.templateId === 0 && res.data.isCustomized === 1)) {
              projectStore.setCurrentTemplateId(res.data.templateId)
            } else {
              if (route.path === '/design-center') {
                // 标记为新用户（首次进入设计中心且无模板）
                projectStore.isNewUser = true
                nextTick(() => {
                  headerStore.showSelectTemplatePopup()
                })
              }
            }
          }
        })
        .catch(error => {
          console.error('Failed to initialize project:', error)
        })
    }
  } else {
    // PDF 服务在无痕 Chromium 中打开固定打印地址，登录凭证只由 Node 服务按
    // API origin 白名单转发，不写入页面 Cookie、localStorage 或 URL。
    // 仅打印模式跳过页面侧登录态判断；普通 PDF 编辑页仍保持原有登录校验。
    if (isPdfPrintRoute.value) {
      projectStore.$patch(state => {
        state.isInitialized = true
      })
      return
    }

    const isShareLink =
      route.query.share === '1' ||
      (typeof route.query.shareId === 'string' && route.query.shareId.length > 0) ||
      (typeof route.query.emailShareId === 'string' && route.query.emailShareId.length > 0)

    // PDF 服务在无痕 Chromium 中打开固定打印地址，登录凭证只由 Node 服务按
    // API origin 白名单转发，不写入页面 Cookie、localStorage 或 URL。
    // 仅打印模式跳过页面侧登录态判断；普通 PDF 编辑页仍保持原有登录校验。
    if (isPdfPrintRoute.value) {
      projectStore.$patch(state => {
        state.isInitialized = true
      })
      return
    }

    // 仅公开路由和受支持的分享链接可跳过登录校验。
    if (route.meta.public || isShareLink) {
      projectStore.$patch(state => {
        state.isInitialized = true
      })
      return
    }

    if (
      location.host.includes('whgxwl.com') ||
      location.host.includes('design-center') ||
      location.host.includes('feisu')
    ) {
      location.href = handleFsLink(`/login.html?redirect=${setLoginUrl()}`)
    }
  }
})
onUnmounted(() => {
  if (tracker) {
    tracker.destroy()
  }
})
watch(
  () => userStore.userInfo,
  userInfo => {
    if (userInfo) {
      Sentry.setUser({
        username: userStore?.userInfo?.customers_firstname + ' ' + userStore?.userInfo?.customers_lastname,
        email: userStore?.userInfo?.customers_email_address,
      })
    }
  },
  { immediate: true }
)
</script>

<style lang="scss">
#mainApp {
  height: 100vh;
  width: 100vw;
}
</style>

<style lang="scss" scoped>
.loading-container {
  height: 100vh;
  width: 100vw;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  @include font14;
}
</style>
